// Permanent places of the Bloom World, drawn in the Bloom illustration style.
// The places stay from Year 1 to Year 6 — what grows on them matures with the child.

export function CountingTree({ className, fruit = ["1", "2", "3"] }) {
  const size = (g) => (String(g).length > 2 ? 9 : String(g).length > 1 ? 11.5 : 15);
  return (
    <svg viewBox="0 0 150 160" className={className} role="img" aria-label="The Counting Tree — Maths">
      <path d="M68 160 L68 100 Q64 88 52 80 L58 74 Q70 82 74 92 Q78 80 92 72 L97 79 Q84 86 81 100 L81 160 Z" fill="#A9746E" />
      <circle cx="75" cy="58" r="46" fill="#57C690" />
      <circle cx="37" cy="74" r="26" fill="#4DBC85" />
      <circle cx="113" cy="72" r="25" fill="#4DBC85" />
      <ellipse cx="58" cy="42" rx="22" ry="14" fill="#7BD8A8" opacity="0.8" />
      {[{ x: 46, y: 66 }, { x: 78, y: 42 }, { x: 104, y: 70 }].map(({ x, y }, i) => (
        <g key={i}>
          <circle cx={x} cy={y} r="13" fill="#FF7A45" />
          <circle cx={x - 4} cy={y - 4} r="3.5" fill="#FFFFFF" opacity="0.5" />
          <text x={x} y={y + 5} textAnchor="middle" fontFamily="Nunito, sans-serif" fontWeight="900" fontSize={size(fruit[i])} fill="#FFFFFF">
            {fruit[i]}
          </text>
        </g>
      ))}
    </svg>
  );
}

export function StoryBook({ className, glyphs = ["A", "b", "c"] }) {
  return (
    <svg viewBox="0 0 160 130" className={className} role="img" aria-label="The Story Book — English">
      <ellipse cx="80" cy="118" rx="44" ry="9" fill="#A9746E" />
      <rect x="60" y="96" width="40" height="24" rx="6" fill="#B98378" />
      <path d="M80 58 Q48 46 22 56 L22 96 Q48 86 80 96 Z" fill="#FFFFFF" stroke="#EAE6E1" strokeWidth="2" />
      <path d="M80 58 Q112 46 138 56 L138 96 Q112 86 80 96 Z" fill="#FFF9F0" stroke="#EAE6E1" strokeWidth="2" />
      <path d="M80 58 L80 96" stroke="#EAE6E1" strokeWidth="2.5" />
      {[66, 74, 82].map((y) => (
        <path key={y} d={`M32 ${y} Q52 ${y - 6} 72 ${y}`} stroke="#D8D2CA" strokeWidth="3" strokeLinecap="round" fill="none" />
      ))}
      <path d="M92 64 Q108 58 126 62 M92 74 Q108 68 126 72 M92 84 Q104 79 116 82" stroke="#D8D2CA" strokeWidth="3" strokeLinecap="round" fill="none" />
      <text x="40" y="36" fontFamily="Nunito, sans-serif" fontWeight="900" fontSize="26" fill="#FF7A45" transform="rotate(-12 40 36)">{glyphs[0]}</text>
      <text x="76" y="22" fontFamily="Nunito, sans-serif" fontWeight="900" fontSize="22" fill="#118AB2">{glyphs[1]}</text>
      <text x="108" y="34" fontFamily="Nunito, sans-serif" fontWeight="900" fontSize="20" fill="#06D6A0" transform="rotate(10 108 34)">{glyphs[2]}</text>
      <path d="M134 16 l1.6 4.6 4.6 1.6 -4.6 1.6 -1.6 4.6 -1.6 -4.6 -4.6 -1.6 4.6 -1.6z" fill="#FFD166" />
    </svg>
  );
}

export function Postbox({ className, extraMail = false }) {
  return (
    <svg viewBox="0 0 90 130" className={className} role="img" aria-label="The Postbox — Homework">
      <ellipse cx="45" cy="124" rx="26" ry="6" fill="#2B2D42" opacity="0.12" />
      <rect x="38" y="96" width="14" height="28" rx="5" fill="#C9354F" />
      <rect x="20" y="26" width="50" height="76" rx="16" fill="#EF476F" />
      <path d="M20 42 a25 22 0 0 1 50 0 Z" fill="#E63A60" />
      <rect x="30" y="44" width="30" height="7" rx="3.5" fill="#7A1A32" />
      <rect x="33" y="38" width="20" height="12" rx="2.5" fill="#FFFFFF" transform="rotate(-6 43 44)" />
      <path d="M34 36 l9 7 9 -9" stroke="#EAE6E1" strokeWidth="1.6" fill="none" transform="rotate(-6 43 44)" />
      <circle cx="37" cy="66" r="3.2" fill="#2B2D42" />
      <circle cx="53" cy="66" r="3.2" fill="#2B2D42" />
      <circle cx="38.2" cy="64.8" r="1" fill="#FFFFFF" />
      <circle cx="54.2" cy="64.8" r="1" fill="#FFFFFF" />
      <path d="M38 76 Q45 83 52 76" stroke="#2B2D42" strokeWidth="3" strokeLinecap="round" fill="none" />
      <circle cx="31" cy="73" r="3.5" fill="#FFD166" opacity="0.75" />
      <circle cx="59" cy="73" r="3.5" fill="#FFD166" opacity="0.75" />
      {extraMail && (
        <g>
          <rect x="4" y="106" width="22" height="14" rx="3" fill="#FFFFFF" stroke="#EAE6E1" strokeWidth="1.5" transform="rotate(-8 15 113)" />
          <path d="M5 108 l10 7 10 -8" stroke="#D8D2CA" strokeWidth="1.5" fill="none" transform="rotate(-8 15 113)" />
          <rect x="64" y="110" width="20" height="13" rx="3" fill="#FFF9F0" stroke="#EAE6E1" strokeWidth="1.5" transform="rotate(7 74 116)" />
        </g>
      )}
    </svg>
  );
}

export function MyPlaceDen({ className, band = "early" }) {
  return (
    <svg viewBox="0 0 150 120" className={className} role="img" aria-label="My Place — your own den">
      <ellipse cx="75" cy="114" rx="58" ry="7" fill="#2B2D42" opacity="0.1" />
      <path d="M75 10 L18 112 L132 112 Z" fill="#FFD166" />
      <path d="M75 10 L47 112 L61 112 Z" fill="#FFF3D6" />
      <path d="M75 10 L103 112 L89 112 Z" fill="#FFF3D6" />
      <path d="M75 38 L58 112 L92 112 Z" fill="#8C5A3C" />
      <path d="M75 44 L62 108 L88 108 Z" fill="#5F3B24" />
      <path d="M75 10 L75 -2" stroke="#A9746E" strokeWidth="4" strokeLinecap="round" />
      <path d="M75 -2 L98 4 L75 10 Z" fill="#FF7A45" />
      <circle cx="75" cy="34" r="5" fill="#FF7A45" />
      <path d="M40 92 q4 -8 10 0 M100 92 q4 -8 10 0" stroke="#E8B84A" strokeWidth="3" strokeLinecap="round" fill="none" />
      {band !== "early" && (
        <g>
          <path d="M30 62 Q75 78 120 62" stroke="#FFFFFF" strokeWidth="2" fill="none" opacity="0.9" />
          {[[42, 66], [60, 70], [78, 71], [96, 68]].map(([x, y], i) => (
            <path key={i} d={`M${x} ${y} l9 3 -9 5 z`} fill={["#FF7A45", "#06D6A0", "#118AB2", "#EF476F"][i]} />
          ))}
        </g>
      )}
      {band === "upper" && (
        <g>
          <circle cx="112" cy="94" r="9" fill="#FFF3D6" stroke="#E8B84A" strokeWidth="2" />
          <path d="M112 89 l1.7 3.4 3.8 0.6 -2.7 2.7 0.6 3.8 -3.4 -1.8 -3.4 1.8 0.6 -3.8 -2.7 -2.7 3.8 -0.6 z" fill="#FFB84D" />
        </g>
      )}
    </svg>
  );
}

export function AdventureSign({ className }) {
  return (
    <svg viewBox="0 0 150 150" className={className} role="img" aria-label="Today's Adventure signpost">
      <ellipse cx="75" cy="144" rx="30" ry="6" fill="#2B2D42" opacity="0.12" />
      <rect x="68" y="52" width="13" height="92" rx="6" fill="#A9746E" />
      <rect x="70.5" y="52" width="4" height="92" rx="2" fill="#B98378" />
      <path d="M22 26 L110 26 Q116 26 120 31 L134 48 L120 65 Q116 70 110 70 L22 70 Q14 70 14 62 L14 34 Q14 26 22 26 Z" fill="#FFB84D" stroke="#E8920C" strokeWidth="3" />
      <path d="M60 34 l4.6 9.3 10.3 1.5 -7.4 7.3 1.7 10.2 -9.2 -4.8 -9.2 4.8 1.7 -10.2 -7.4 -7.3 10.3 -1.5 z" fill="#FFFFFF" />
      <text x="106" y="56" textAnchor="middle" fontFamily="Nunito, sans-serif" fontWeight="900" fontSize="21" fill="#7C3E0A">GO!</text>
      <circle cx="26" cy="86" r="3" fill="#FFD166" />
      <circle cx="120" cy="90" r="2.5" fill="#FFD166" />
    </svg>
  );
}
